import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f9efd202"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src", "width", "height"]

import { computed, onMounted, ref } from 'vue'

import { getImage, QuestionnaireView } from '@/models/onboarding'
import { Welcome16167Page } from '@/models/onboarding.types'
import { PublicInterface } from '@/models/interfaces'

import Rive from '@/app/components/Rive.vue'
import Layout from '../Layout.vue'
import Welcome16167Intro from '../Welcome16167Intro.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Welcome16167',
  props: {
    view: null
  },
  setup(__props: any) {

const props = __props as {
  view: PublicInterface<QuestionnaireView>
};



const page = computed(() => {
  return props.view.currentPage as Welcome16167Page
})

const animationKeyframes = {
  intro: 0,
  showMascot: 2500,
  updateText: 3000,
  showButton: 5200,
}
const currentKeyframe = ref<keyof typeof animationKeyframes>('intro')

onMounted(() => {
  setTimeout(() => {
    currentKeyframe.value = 'showMascot'
    props.view.showLogo()
  }, animationKeyframes.showMascot)

  setTimeout(() => {
    currentKeyframe.value = 'updateText'
  }, animationKeyframes.updateText)

  setTimeout(() => {
    currentKeyframe.value = 'showButton'
    props.view.showContinueButton()
  }, animationKeyframes.showButton)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Layout, {
    class: _normalizeClass(["onboarding-welcome16167", `onboarding-welcome16167--${currentKeyframe.value}`]),
    title: _unref(page).title,
    subtitle: _unref(page).subtitle
  }, {
    default: _withCtx(() => [
      _createVNode(Welcome16167Intro, {
        title: _unref(page).introTitle,
        class: "onboarding-welcome16167__intro"
      }, null, 8, ["title"]),
      (currentKeyframe.value !== 'intro')
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _unref(getImage)(_unref(page).image.src),
            width: _unref(page).image.width,
            height: _unref(page).image.height,
            class: "onboarding-welcome16167__mascot"
          }, null, 8, _hoisted_1))
        : _createCommentVNode("", true),
      _withDirectives(_createVNode(Rive, {
        class: "onboarding-welcome16167__rive",
        src: _unref(getImage)('preload.riv')
      }, null, 8, ["src"]), [
        [_vShow, false]
      ])
    ]),
    _: 1
  }, 8, ["class", "title", "subtitle"]))
}
}

})